<div class="confirm-dialog-container">
  <h1 mat-dialog-title class="confirm-dialog-title">{{title}}</h1>
  <div class="confirm-dialog-message" mat-dialog-content>
    <p [innerHTML]="confirmMessage"></p>
  </div>
  <div class="confirm-dialog-actions" mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="dialogRef.close(true)">{{okButtonLabel}}</button>
    <button mat-raised-button *ngIf="showCancelButton" (click)="dialogRef.close(false)">{{cancelButtonLabel}}</button>
  </div>
</div>
